import { render } from "./AnimationWrapper.vue?vue&type=template&id=46cd85c4"
import script from "./AnimationWrapper.vue?vue&type=script&lang=js"
export * from "./AnimationWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/common/components/AnimationWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "46cd85c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('46cd85c4', __exports__)) {
    api.reload('46cd85c4', __exports__)
  }
  
  module.hot.accept("./AnimationWrapper.vue?vue&type=template&id=46cd85c4", () => {
    api.rerender('46cd85c4', render)
  })

}


export default __exports__